const styles = () => ({
  root: {},
})

export default styles
